//自定义表单表头： 国际化翻译中英对应关系表
export default {
    "数据标题": 'Data Title',
    "创建人": 'Creater',
    "创建时间": 'Creation Time',
    "单据号": 'Sequence No.',
    "业务对象": 'Business Object',
    "业务对象ID": 'Business Object ID',
    "创建人部门": 'Dept. Of Creater',
    "拥有者": 'Owner',
    "拥有者部门": 'Dept. Of Owner',
    "修改人": 'Modifier',
    "修改时间": 'Modification Time',
    "单据状态": 'Sequece Status',
};
